var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2967 26H6.70476C4.74212 26 3.16406 24.6565 3.16406 23.0106V9.98939C3.16406 8.33235 4.75539 7 6.70476 7H25.2967C27.2593 7 28.8374 8.34355 28.8374 9.98939V23.0106C28.8374 24.6565 27.2461 26 25.2967 26Z",
    fill: "#74B743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6795 11.9458L19.044 19.873C17.2221 21.3719 14.6021 21.3953 12.7571 19.9291L3 12.1758",
    stroke: "#E3F1D9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesActive);
export default __webpack_public_path__ + "static/media/messages-active.2faad87a265daf27ea9ca7b1f429f2ec.svg";
export { ForwardRef as ReactComponent };